import { render } from "./KitchenDisplayMetricChips.vue?vue&type=template&id=1ca35d68"
import script from "./KitchenDisplayMetricChips.vue?vue&type=script&lang=js"
export * from "./KitchenDisplayMetricChips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
